import { LeadTypes } from "@leadpro/forms";
import {
  ALL_LEAD_TYPES,
  TLeadTypeSelection,
} from "constants/lead-type-options";
import { TSourceOfficeSelection } from "constants/lead-inactivity";
import { LeadInactivityTypeEnum } from "enums/lead-inactivity-type.enum";
import * as Yup from "yup";

const baseInactivitySchema = {
  enabled: Yup.boolean().required(),
  delay: Yup.number()
    .nullable()
    .integer("Enter a whole number of minutes.")
    .min(1, "Enter a waiting time of at least 1 minute.")
    .max(480, "Enter a waiting time of 480 minutes or less.")
    .required("Enter how long to wait before redirecting."),
  triggerWithinOfficeHours: Yup.boolean().required(),
  type: Yup.mixed<LeadInactivityTypeEnum>()
    .oneOf(Object.values(LeadInactivityTypeEnum))
    .required("Select an action."),
  leadTypes: Yup.array()
    .of(
      Yup.mixed<TLeadTypeSelection>()
        .oneOf([ALL_LEAD_TYPES, ...Object.values(LeadTypes)])
        .required()
    )
    .min(1, "Select at least one lead type.")
    .required(),
  sourceOfficeIds: Yup.array()
    .of(Yup.mixed<TSourceOfficeSelection>().required())
    .min(1, "Select at least one source office.")
    .required(),
};

const rerouteActionConfigSchema = {
  officeId: Yup.number()
    .nullable()
    .when("type", {
      is: LeadInactivityTypeEnum.REROUTE_TO_OFFICE,
      then: schema => schema.required("Select an office to redirect to."),
    }),
};

export const leadInactivityValidationSchema = Yup.object({
  ...baseInactivitySchema,
  ...rerouteActionConfigSchema,
});
